<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'editConclusionVolumeDialog.title' | translate }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.supplierName' | translate }}</mat-label>
      <input matInput [(ngModel)]="applicantName" name="applicantName" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.quotaYear' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="quotaYear" name="quotaYear" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.meatType' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedMeatType" name="meatType" required>
        @for (meatType of meatTypes(); track meatType.id) {
          <mat-option [value]="meatType">{{ getMeatTypeName(meatType) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.distributedVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="distributedVolume" name="distributedVolume" min="0.001" step="0.001" required>
      <mat-hint>{{ 'editConclusionVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.deliveredVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="deliveredVolume" name="deliveredVolume" min="0.001" step="0.001" required>
      <mat-hint>{{ 'editConclusionVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.pin' | translate }}</mat-label>
      <input matInput [(ngModel)]="personIdnp" name="personIdnp" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'editConclusionVolumeDialog.organizationInn' | translate }}</mat-label>
      <input matInput [(ngModel)]="organizationInn" name="organizationInn" required>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">{{ 'editConclusionVolumeDialog.cancel' | translate }}</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ 'editConclusionVolumeDialog.signAndSave' | translate }}
    }
  </button>
</mat-dialog-actions>
